<template>
  <div>
    <div class="black-overlay"></div>
    <div class="modal modal--prize-details" id="prize-details_modal">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header">
          <h2 v-if="getShowmodalForDefaultPrizeDetails.type === 'DAILY'">
            {{ getTranslations.home_modals_prize_details_daily_prize }}</h2>
          <h2 v-if="getShowmodalForDefaultPrizeDetails.type === 'WEEKLY'">
            {{ getTranslations.home_modals_prize_details_weekly_prize }}</h2>
          <h2 v-if="getShowmodalForDefaultPrizeDetails.type === 'MONTHLY'">
            {{ getTranslations.home_modals_prize_details_monthly_prize }}</h2>
          <h2 v-if="getShowmodalForDefaultPrizeDetails.type === 'GRAND'">
            {{ getTranslations.home_modals_prize_details_grand_prize }}</h2>
          <h1 v-if="getShowmodalForDefaultPrizeDetails.type === 'DAILY'">
            {{ getShowmodalForDefaultPrizeDetails.activeFrom | getFormat }}</h1>
          <h1 v-else>{{ getShowmodalForDefaultPrizeDetails.activeFrom | getFormat
            }} - {{ getShowmodalForDefaultPrizeDetails.activeTo | getFormat }}</h1>
        </div>
        <div class="modal__body">
          <img :src="getShowmodalForDefaultPrizeDetails.imgUrl" alt="">
          <span class="prize-text">{{ getShowmodalForDefaultPrizeDetails.headline }}</span>
          <div class="modal-section">
            <h2 class="modal-section__title">{{ getTranslations.home_modals_prize_details_who_wins }}</h2>
            <div class="modal-section__body">
              <p>{{ getShowmodalForDefaultPrizeDetails.description }}</p>
            </div>
          </div>
          <div class="modal-section">
            <h2 class="modal-section__title">{{ getTranslations.home_modals_prize_details_eligibility }}</h2>
            <div class="modal-section__body">
              <p>{{ getShowmodalForDefaultPrizeDetails.eligibilityCriteria }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Vue from 'vue';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'prize-details',
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('profile', [
      'getShowmodalForDefaultPrizeDetails',
    ]),
  },
  filters: {
    getFormat(date) {
      return moment(date).format('DD/MM/YYYY');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/PrizeDetails.vue